module.exports = __webpack_public_path__ + "h5/img/huangka_1.80a32d17.png";